{
	"orderQtyInput": {
		"qty": "Количество",
		"available": "в наличии",
		"shareOfPortfolio": "Доля от портфеля, %",
		"amount": "Сумма, в USD",
		"pcs": "шт."
	}
}
